import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const LibraryTypeSwitch = (props) => (
  <div className='l-container'>
    <nav className='course-nav-1 course-nav-1--compact'>
      <Link
        to={'/courses'}
        onClick={(e) => props.handleTypeClick('tutored', e)}
        className={props.courseType === 'tutored' ? 'is-active' : ''}>
        <svg className='icon icon-people' aria-hidden='true'><use xlinkHref='#people' /></svg>
        <strong className='course-nav-1__title'>Tutored <span className='extra'>Courses</span></strong>
      </Link>
      <Link
        to={'/courses'}
        onClick={(e) => props.handleTypeClick('independent', e)}
        className={props.courseType === 'independent' ? 'is-active' : ''}>
        <svg className='icon icon-person' aria-hidden='true'><use xlinkHref='#person' /></svg>
        <strong className='course-nav-1__title'>Independent <span className='extra'>Courses</span></strong>
      </Link>
    </nav>
  </div>
);

LibraryTypeSwitch.propTypes = {
  handleTypeClick: PropTypes.func,
  courseType: PropTypes.string
};

export default LibraryTypeSwitch;



// WEBPACK FOOTER //
// ./src/components/LibraryTypeSwitch/index.js